<template>
  <b-container v-if="pages" fluid>
    <b-row class="sticky-top">
      <b-col>
        <Header :locale.sync="locale" :menus="menus" v-bind="headers[locale]" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <router-view 
          :key="computedPath" 
          :locale="locale" 
          :label="label" 
          :components="components" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <Footer :locale="locale" v-bind="footers[locale]" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  props: {
    headers: Object,
    pages: Object,
		footers: Object
  },
  data() {
    return {
      locale: 'en'
    }
  },
  computed: {
    computedPath() {
      return this.$route.fullPath.replace(/\/$/, "")
    },
    components() {
      return this.pages[this.locale][this.computedPath].components
    },
    label() {
      return this.pages[this.locale][this.computedPath].label
    },
    menus() {
      const orderedPages = 
        /* eslint-disable-next-line */
        Object.entries(this.pages[this.locale]).filter(([path, attributes]) => attributes.position > 0).sort((p1, p2) => p1[1].position < p2[1].position ? -1 : 1)
      return orderedPages.map(([path, attributes]) => ({ path: path, label: attributes.label }))
    }
  },
  metaInfo: {
    title: 'Home',
    titleTemplate: '%s | Mt. Sinai Million'
  },
	beforeMount() {
		this.locale = this.computedPath.split('/')[1]
	},
  watch: {
    locale: function (newVal) {
			// TODO: Look into improving locale change handling
			const fullPath = this.computedPath.replace(/^\//, "").split('/')
			const suffix = fullPath.slice(1).join('/')
			const newPath = `/${newVal}/${suffix}`
			if (newPath !== this.computedPath) {
        console.log(`Pushing ${newPath}`)
				this.$router.push({ path: newPath })
			}
    }
  }
}
</script>

<style>
@import "./assets/css/app.css";
</style>
